import { committee_list } from './committee_list'
import InstructorCard from './InstructorCard'

const OrganizationCommittee = () => {
  return (
    <section id='instructors' className='committee'>
        <h2>Düzenleme Kurulu</h2>
        <div className="cards">
            {
                committee_list.map((member, index) => (
                    <InstructorCard
                        key={`c_member_${index}`}
                        name={member.name}
                        title={member.title}
                        image = {member.image}
                        url = {member.url}
                    /> 
                ))
            }
        </div>
    </section>
  )
}

export default OrganizationCommittee